import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
    providedIn: 'root'
})
export class AppointmentService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    get(data): Observable<any> {
        return this.getRequest(AppUrl.APPOINTMENTS(), data);
    }

    getAppointmentDocs(id): Observable<any> {
        return this.getRequest(AppUrl.APPOINTMENT_DOCS(id));
    }

    count(): Observable<any> {
        return this.getRequest(AppUrl.APPOINTMENTS_COUNT());
    }

    detail(id): Observable<any> {
        return this.getRequest(AppUrl.APPOINTMENTS(id));
    }

    create(data): Observable<any> {
        return this.postRequest(AppUrl.APPOINTMENTS(), data);
    }

    update(id, data): Observable<any> {
        return this.putRequest(AppUrl.APPOINTMENTS(id), data);
    }

    updateStatus(id, data): Observable<any> {
        return this.putRequest(AppUrl.APPOINTMENT_STATUS(id), data);
    }
}
